import { AxiosResponse } from 'axios'
import {useQuery, UseQueryOptions, useMutation, UseQueryResult} from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys }     from './_query_keys'
import { HttpRequest }  from '../services/_http'

export const useUsersData = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {
    
    const method   = 'GET'
    const queryKey = [QueryKeys.ADMIN_USERS,searchOptions]
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.AdminUsers}`,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        cacheTime: 0,
        ...options
    })
}

export const useAddUser = (options?: any) => {
    
    const method = 'POST'
    
    return useMutation(({data}: {data: any})=> HttpRequest({
        url: `${APIEndpoints.AdminUsers}`,
        method,
        data
    }), options)
}

export const useUpdateUser = (options?: any) => {
    
    const method = 'PUT'
    
    return useMutation(({data, id}: {data: any, id: any})=> HttpRequest({
        url: `${APIEndpoints.AdminUsers}/${id}`,
        method,
        data
    }), options)
}

export const useDeleteUser = (options?: any) => {
    
    const method = 'DELETE'
    
    return useMutation(({id}: {id: any})=> HttpRequest({
        url: `${APIEndpoints.AdminUsers}/${id}`,
        method,
    }), options)
}

export const useSendResetPasswordLink = (options?: any) => {
    const method = 'POST'
    return useMutation(({data}: {data: any})=> HttpRequest({
        url: `${APIEndpoints.Auth.ForgotPassword}`,
        method,
        data
    }), options)
}

export const useResetPassword = (options?: any): AxiosResponse | any => {
    const method = 'POST'
    return useMutation(({data}: {data: any})=> HttpRequest({
        url: `${APIEndpoints.Auth.ResetPassword}`,
        method,
        data
    }), options)
}